/** Deterministic test/bot hook: exposes read-only state when the URL has ?bot=1 (no Phaser, no telemetry). */
export function exposeBotHook(api: Record<string, (...args: never[]) => unknown>): void {
  if (new URLSearchParams(location.search).has("bot")) (window as unknown as { __arcade: unknown }).__arcade = api;
}
